export default __webpack_public_path__ + "static/media/noVideo.d200ed3d.jpg";